<template>
  <CIcon :name="inactive ? 'radio-urgency-off' : 'radio-urgency-on'" :size="size" class="c-severity" :class="rootClasses"/>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import Severity from '../constants/Severity';
  import CIcon from './CIcon.vue';

  const props = defineProps<{
    severity: Severity;
    inactive?: boolean;
    size?: number;
  }>();

  const rootClasses = computed(() => {
    switch (props.severity) {
      case Severity.GOOD:
        return 'c-severity-good';
      case Severity.CAUTION:
        return 'c-severity-caution';
      case Severity.BAD:
        return 'c-severity-bad';
    }
  });
</script>

<style lang="scss">
  .c-severity {
    display: inline;

    &-good {
      color: $success;
    }

    &-caution {
      color: $warning;
    }

    &-bad {
      color: $danger;
    }
  }
</style>
